import { WaypointType, WaypointData } from "./components/directions/waypoint.js";
import { DirectionsAppState } from "./directions/directions.js";

export class GeomapUtil {
    private static _instance: GeomapUtil;
    private _colorsArr: Array<string>;

    private constructor() {
    }

    static getInstance = () => {
        if (GeomapUtil._instance == null) {
            GeomapUtil._instance = new GeomapUtil();
            GeomapUtil._instance._colorsArr = ["rgb(100, 110, 180)", "rgb(204, 51, 102)", "rgb(105, 105, 105)", "rgb(34, 139, 34)", "rgb(255, 165, 0)", "rgb(65, 105, 225)", "rgb(210,105,30)", "rgb(165, 42, 42)", "rgb(176, 196, 222)", "rgb(154, 205, 50)"];
        }

        return GeomapUtil._instance;
    }

    static init = (colors: Array<string>) => {
        if (GeomapUtil._instance == null) {
            GeomapUtil._instance = new GeomapUtil();
            GeomapUtil._instance._colorsArr = colors;
        }
        else {
            throw "GeomapUtil is already initialized!";
        }
    }

    getObjectIndexByProperty = (arr: Array<any>, name: string, value: any) => {
        return arr.map((e) => { return e[name] }).indexOf(value);
    }

    parseGridConfigJson = (jsonObject: any, gridType: string) => {
        if (jsonObject.grids) {
            return jsonObject.grids[this.getObjectIndexByProperty(jsonObject.grids, "name", gridType)].data;
        }
    }

    getGeocodedWaypoints = (wpa: Array<WaypointData>) => {
        return wpa.filter((wp) => {
            return (wp.lat != null && wp.lng != null && (wp.lat !== 0 || wp.lng !== 0));
        });
    }

    getWaypointsWithoutGeocode = (wpa: Array<WaypointData>) => {
        return wpa.filter((wp) => {
            return (wp.lat == null || wp.lng == null || (wp.lat === 0 && wp.lng === 0));
        });
    }

    getPropertyByLowerCase = (obj: Object, prop: string) => {
        prop = (prop).toLowerCase();
        for (let p in obj) {
            if (obj.hasOwnProperty(p) && prop == (p).toLowerCase()) {
                return obj[p];
            }
        }
    }

    mapToWaypoint = (entity: any, entityType: GeomapEntityType, useTempCoordinates: boolean = false) => {
        let waypoint: any = {};
        let id = kendo.guid();
        waypoint.id = id;
        waypoint.entity = this.cloneToLowerCase(entity);
        waypoint.useTempCoordinates = null;
        switch (entityType) {
            case GeomapEntityType.AddressViewEntity: {
                waypoint.no = this.getPropertyByLowerCase(entity, "adrnr");
                waypoint.entityId = this.getPropertyByLowerCase(entity, "adrnr");
                waypoint.name = this.getPropertyByLowerCase(entity, "adrname");
                waypoint.description = (this.getPropertyByLowerCase(entity, "strasse") || '') + ' ' + (this.getPropertyByLowerCase(entity, "plz") || '') + ' ' + (this.getPropertyByLowerCase(entity, "ort") || '');
                waypoint.address = (this.getPropertyByLowerCase(entity, "strasse") || '') + ' ' + (this.getPropertyByLowerCase(entity, "plz") || '') + ' ' + (this.getPropertyByLowerCase(entity, "ort") || '');
                waypoint.lat = this.getPropertyByLowerCase(entity, "breitegrad");
                waypoint.lng = this.getPropertyByLowerCase(entity, "laengegrad");
                waypoint.adrnr = this.getPropertyByLowerCase(entity, "adrnr");
                waypoint.waypointType = WaypointType.ADDRESS;
                break;
            }
            case GeomapEntityType.MachineViewEntity: {
                waypoint.no = this.getPropertyByLowerCase(entity, "maschnr");
                waypoint.entityId = this.getPropertyByLowerCase(entity, "maschnr");
                waypoint.name = this.getPropertyByLowerCase(entity, "maschbezeichnung");
                waypoint.description = (this.getPropertyByLowerCase(entity, "strasse") || '') + ' ' + (this.getPropertyByLowerCase(entity, "plz") || '') + ' ' + (this.getPropertyByLowerCase(entity, "ort") || '');
                waypoint.address = (this.getPropertyByLowerCase(entity, "strasse") || '') + ' ' + (this.getPropertyByLowerCase(entity, "plz") || '') + ' ' + (this.getPropertyByLowerCase(entity, "ort") || '');
                waypoint.lat = this.getPropertyByLowerCase(entity, "breitegrad");
                waypoint.lng = this.getPropertyByLowerCase(entity, "laengegrad");
                waypoint.adrnr = this.getPropertyByLowerCase(entity, "adrnr");
                waypoint.waypointType = WaypointType.MACHINE;
                break;
            }
            case GeomapEntityType.ResourceViewEntity: {
                waypoint.no = this.getPropertyByLowerCase(entity, "ressnr");
                waypoint.entityId = this.getPropertyByLowerCase(entity, "ressnr");
                waypoint.name = this.getPropertyByLowerCase(entity, "name");
                waypoint.description = (this.getPropertyByLowerCase(entity, "strasse") || '') + ' ' + (this.getPropertyByLowerCase(entity, "plz") || '') + ' ' + (this.getPropertyByLowerCase(entity, "ort") || '');
                waypoint.address = (this.getPropertyByLowerCase(entity, "strasse") || '') + ' ' + (this.getPropertyByLowerCase(entity, "plz") || '') + ' ' + (this.getPropertyByLowerCase(entity, "ort") || '');
                if (useTempCoordinates) {
                    waypoint.lat = this.getPropertyByLowerCase(entity, "tempbreitegrad");
                    waypoint.lng = this.getPropertyByLowerCase(entity, "templaengegrad");
                    waypoint.useTempCoordinates = true;
                }
                if (!useTempCoordinates || !this.isWaypointGeocoded(waypoint)) {
                    waypoint.lat = this.getPropertyByLowerCase(entity, "breitegrad");
                    waypoint.lng = this.getPropertyByLowerCase(entity, "laengegrad");
                    waypoint.useTempCoordinates = false;
                }
                waypoint.adrnr = this.getPropertyByLowerCase(entity, "adrnr");
                waypoint.waypointType = WaypointType.RESOURCE;

                break;
            }
            case GeomapEntityType.AssignmentViewEntity: {
                waypoint.no = this.getPropertyByLowerCase(entity, "adrnr");
                waypoint.entityId = { projnr: this.getPropertyByLowerCase(entity, "projnr"), pindex: this.getPropertyByLowerCase(entity, "pindex") };
                waypoint.name = this.getPropertyByLowerCase(entity, "adrname");
                waypoint.description = (this.getPropertyByLowerCase(entity, "strasse") || '') + ' ' + (this.getPropertyByLowerCase(entity, "plz") || '') + ' ' + (this.getPropertyByLowerCase(entity, "ort") || '');
                waypoint.address = (this.getPropertyByLowerCase(entity, "strasse") || '') + ' ' + (this.getPropertyByLowerCase(entity, "plz") || '') + ' ' + (this.getPropertyByLowerCase(entity, "ort") || '');
                waypoint.lat = this.getPropertyByLowerCase(entity, "breitegrad");
                waypoint.lng = this.getPropertyByLowerCase(entity, "laengegrad");
                waypoint.adrnr = this.getPropertyByLowerCase(entity, "adrnr");
                waypoint.waypointType = WaypointType.ASSIGNMENT;
                break;
            }
            case GeomapEntityType.TicketViewEntity: {
                waypoint.no = this.getPropertyByLowerCase(entity, "problemnr");
                waypoint.entityId = this.getPropertyByLowerCase(entity, "problemnr");
                waypoint.name = this.getPropertyByLowerCase(entity, "adrname");
                waypoint.description = (this.getPropertyByLowerCase(entity, "strasse") || '') + ' ' + (this.getPropertyByLowerCase(entity, "plz") || '') + ' ' + (this.getPropertyByLowerCase(entity, "ort") || '');
                waypoint.address = (this.getPropertyByLowerCase(entity, "strasse") || '') + ' ' + (this.getPropertyByLowerCase(entity, "plz") || '') + ' ' + (this.getPropertyByLowerCase(entity, "ort") || '');
                waypoint.lat = this.getPropertyByLowerCase(entity, "breitegrad");
                waypoint.lng = this.getPropertyByLowerCase(entity, "laengegrad");
                waypoint.adrnr = this.getPropertyByLowerCase(entity, "adrnr");
                waypoint.waypointType = WaypointType.TICKET;
                break;
            }
            default: break;
        }
        return waypoint as WaypointData;
    }

    mapToGeomapEntityType = (pt: PointType) => {
        switch (pt) {
            case PointType.Address: {
                return GeomapEntityType.AddressViewEntity;
            }
            case PointType.Machine: {
                return GeomapEntityType.MachineViewEntity;
            }
            case PointType.Resource: {
                return GeomapEntityType.ResourceViewEntity;
            }
            case PointType.Assignment: {
                return GeomapEntityType.AssignmentViewEntity;
            }
            case PointType.Ticket: {
                return GeomapEntityType.TicketViewEntity;
            }
        }
    }

    mapFromWaypointTypeToGeomapEntityType = (wpt: WaypointType) => {
        switch (wpt) {
            case WaypointType.ADDRESS: {
                return GeomapEntityType.AddressViewEntity;
            }
            case WaypointType.MACHINE: {
                return GeomapEntityType.MachineViewEntity;
            }
            case WaypointType.RESOURCE: {
                return GeomapEntityType.ResourceViewEntity;
            }
            case WaypointType.ASSIGNMENT: {
                return GeomapEntityType.AssignmentViewEntity;
            }
            case WaypointType.TICKET: {
                return GeomapEntityType.TicketViewEntity;
            }
        }
    }

    getColor = (id: number) => {
        if (id != null) {
            return this._colorsArr[id % this._colorsArr.length];
        }
        else {
            return "rgb(160, 160, 160)";
        }
    }

    getDisplayPattern = (searchType: WaypointType) => {
        switch (searchType) {
            case WaypointType.ADDRESS: {
                return "adrname";
            }
            case WaypointType.MACHINE: {
                return "maschbezeichnung";
            }
            case WaypointType.RESOURCE: {
                return "name";
            }
            case WaypointType.ASSIGNMENT: {
                return "adrname";
            }
            case WaypointType.TICKET: {
                return "problemnr";
            }
        }
    }

    cloneToLowerCase = (objectToClone: Object) => {
        let key: string;
        let keys = Object.keys(objectToClone);
        let n = keys.length;
        let newobj = {};
        while (n--) {
            key = keys[n];
            newobj[key.toLowerCase()] = objectToClone[key];
        }
        return newobj;
    }

    //https://stackoverflow.com/questions/26556436/react-after-render-code/34999925#comment54662760_28748160
    onNextFrame = (callback: FrameRequestCallback) => {
        setTimeout(() => {
            window.requestAnimationFrame(callback);
        }, 0)
    }

    isWaypointGeocoded = (wp: WaypointData) => {
        if (wp.lat == null || wp.lng == null
            || (wp.lat === 0 && wp.lng === 0))
            return false;

        return true;
    }

    getViewPortCoordinates = (e: google.maps.MouseEvent, map: google.maps.Map) => {
        const numTiles = 1 << map.getZoom();
        const projection = map.getProjection();
        const worldCoordinate = projection.fromLatLngToPoint(e.latLng);
        const pixelCoordinate = new google.maps.Point(
            worldCoordinate.x * numTiles,
            worldCoordinate.y * numTiles);

        const topLeft = new google.maps.LatLng(
            map.getBounds().getNorthEast().lat(),
            map.getBounds().getSouthWest().lng()
        );

        const topLeftWorldCoordinate = projection.fromLatLngToPoint(topLeft);
        const topLeftPixelCoordinate = new google.maps.Point(
            topLeftWorldCoordinate.x * numTiles,
            topLeftWorldCoordinate.y * numTiles);

        const clientRect = map.getDiv().getBoundingClientRect();

        return new google.maps.Point(
            pixelCoordinate.x - topLeftPixelCoordinate.x + clientRect.left,
            pixelCoordinate.y - topLeftPixelCoordinate.y + clientRect.top
        )
    }

    isDirectionsAppState(obj: DirectionsAppState | Array<WaypointData>): obj is DirectionsAppState {
        return (obj as DirectionsAppState).routes !== undefined;
    }

    deepCopyArray = <T>(objectArray: Array<T>) => {
        return $.extend(true, [], objectArray) as Array<T>;
    }

}

export interface PointInfo {
    entityType: number;
    entity: any;
    routeId: number;
}

export enum GeomapEntityType {
    AddressViewEntity, MachineViewEntity, ResourceViewEntity,
    AssignmentViewEntity, TicketViewEntity
}

export enum PointType { Address, Machine, Resource, Assignment, Ticket }

export interface GeomapConfig {
    version: string;
    pinTypes: Array<any>;
    containerColors: Array<string>;
    additional: any;
}

export interface RouteObject {
    id: number;
    waypoints: Array<WaypointData>;
    distance?: number;
    time?: number;
    layerSet?: boolean;
    name?: string;
    hide?: boolean;
    color?: string;
    isContextRoute?: boolean;
    routePath?: Array<google.maps.LatLng>;
    legs?: google.maps.DirectionsLeg[];
    ressNr?: string;
}